import { Injectable } from "@angular/core";
import { defer, EMPTY, from, Observable, Subject } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { ReleaseTypesService } from "../../api-kno2fy-main";

@Injectable({
    providedIn: "root"
})
export class ReleaseMonitorService {
    public releaseTypes$ = this.releaseTypesService.getReleaseTypes$();
    constructor(private releaseTypesService: ReleaseTypesService) {}

    public startMonitor$(): Observable<boolean> {
        return this.releaseTypes$.pipe(
            switchMap((releaseTypes) => defer(() => from(window.api.setReleaseTypes({ payload: releaseTypes })))),
            map(({ success }: IpcResponse) => <boolean>success)
        );
    }

    public releaseJob$(): Observable<ReleaseJobPayload> {
        const emitter = new Subject<string>();

        window.api.registerReleaseJobResponder(({ payload }: any) => {
            emitter.next(payload);
        });

        return emitter;
    }

    public syncRequests$(): Observable<void> {
        if (!window.api.registerSyncReleaseTypesResponder) return EMPTY;

        const emitter = new Subject<void>();

        window.api.registerSyncReleaseTypesResponder(() => {
            emitter.next();
        });

        return emitter;
    }
}
